export default __webpack_public_path__ + "static/media/introPic-min.b7e66f2a.jpg";